<template>
  <Dialog v-bind="$attrs" :hide-close-button="true" @close="$emit('close')">
    <template #header-title>Saiba mais</template>
    <template #content>
      A {{ cptdPartnerName }} encontrou um problema com os dados enviados.
      Sentimos muito por isso, mas não se preocupe! Você pode tentar simular
      novamente
    </template>
    <template #footer>
      <Button type="primary" @click="$router.push('/simular')">
        Simular novamente
      </Button>
      <Button type="ghost" @click="$emit('close')"> Cancelar </Button>
    </template>
  </Dialog>
</template>
<script>
import { PartnersName } from '@/helpers/partners/common'
import Dialog from '@/aasgard/components/modals/Dialog.vue'
import Button from '@/aasgard/components/buttons/Button.vue'
export default {
  name: 'FatalErrorDialog',
  components: {
    Dialog,
    Button,
  },
  props: {
    offer: { type: Object, required: true },
    errorReason: { type: String, default: '' },
  },
  emits: ['close'],
  computed: {
    cptdPartner() {
      return this.offer?.partner ?? ''
    },
    cptdPartnerName() {
      return PartnersName[this.cptdPartner ?? ''] ?? ''
    },
  },
}
</script>
<style lang="scss"></style>
